module.exports = __webpack_public_path__ + "fonts/Poppins-100-latin-ext2.d6ad71d.woff2";